import React, { Component } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Edit,
  Toolbar,
  Inject,
  Filter,
  ColumnMenu,
  FilterSettingsModel,
  Resize,
  AggregatesDirective,
  AggregateDirective,
  AggregateColumnsDirective,
  AggregateColumnDirective,
  Aggregate,
  ExcelExport,
  Group,
} from '@syncfusion/ej2-react-grids';
import {
  AddCloudProductionTracking,
  DeleteCloudProductionTracking,
  GetCloudProductionTracking,
  UpdateCloudProductionTracking,
} from '../../services/cloudProductionTracking/CloudProductionTrackingService';
import { loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import { useState } from 'react';

let gridInstance: any;
const toolbarOptions: any = [
  'Add',
  'Edit',
  'Delete',
  'Update',
  'Cancel',
  'ExcelExport',
  'Search',
];
const FilterOptions: FilterSettingsModel = { type: 'Menu' };
const editSettings: any = {
  allowEditing: true,
  allowAdding: true,
  allowDeleting: true,
  newRowPosition: 'Top',
};
const editparams: any = { params: { popupHeight: '300px' } };
const validationRule: Object = { required: true };
const orderidRules: Object = { required: true, number: true };
const format: object = { type: 'date', format: 'dd/MM/yyyy' };
let flag: any;
const CPT = () => {
  const [RemoteCloudData, setRemoteCloudData] = useState();
  const GetCloudData = () => {
    loadingShow(true);
    GetCloudProductionTracking()
      .then((res) => {
        loadingShow(false);
        setRemoteCloudData(res.data);
      })
      .catch((err) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        Message.error(err.config);
        loadingShow(false);
      });
  };
  const actionBegin = (args: any): void => {
    if (args.action === 'add') {
      loadingShow(true);
      const result = args.data;
      AddCloudProductionsTracking(result);
    } else if (args.action === 'edit') {
      loadingShow(true);
      const result = args.data;
      EditCloudProductionTracking(result);
    } else if (args.requestType === 'delete') {
      loadingShow(true);
      DeleteCloudProductionsTracking(args.data);
    }
  };
  const AddCloudProductionsTracking = (obj: Object) => {
    AddCloudProductionTracking(obj).then((res) => {
      if (res.status === 200) {
        GetCloudData();
        Message.success('Add successful');
      } else {
        Message.error('An error occurred during the Add.');
      }
    });
    loadingShow(false);
  };
  const EditCloudProductionTracking = (obj: Object) => {
    UpdateCloudProductionTracking(obj).then((res) => {
      if (res.status === 200) {
        GetCloudData();
        Message.success('update successful');
      } else {
        Message.error('An error occurred during the Update.');
      }
    });
    loadingShow(false);
  };
  const DeleteCloudProductionsTracking = (ID: Object) => {
    DeleteCloudProductionTracking(ID).then((res) => {
      if (res.status === 200) {
        GetCloudData();
        Message.success('Delete successful');
      } else {
        Message.error('An error occurred during the Delete.');
      }
    });
    loadingShow(false);
  };
  const toolbarClick = (args: ClickEventArgs) => {
    if (gridInstance && args.item.id === 'grid_excelexport') {
      gridInstance.excelExport();
    }
  };
  const footerSum = (props: any): any => {
    const val = Object.keys(props)[0].split('-')[0].trim();
    if (val === 'PRODUCT_TRACKING_SITE') {
      return <span style={{ color: 'red' }}>Sum</span>;
    } else {
      var sub = props.Sum?.toString();
      if (sub.includes('.')) {
        var result = parseFloat(sub);
        sub = result.toFixed(3);
      }
      return <span style={{ color: 'red' }}>{parseFloat(sub)}</span>;
    }
  };
  return (
    <div className='col-md-12'>
      <GridComponent
        id='grid'
        dataSource={RemoteCloudData}
        height='74vh'
        ref={(g) => (gridInstance = g)}
        toolbar={toolbarOptions}
        allowExcelExport={true}
        filterSettings={FilterOptions}
        allowFiltering={true}
        showColumnMenu={true}
        allowResizing={true}
        editSettings={editSettings}
        gridLines={'Both'}
        toolbarClick={toolbarClick}
        actionBegin={actionBegin.bind(this)}
        dataBound={() => {
          var searchEle = gridInstance.element.querySelector(
            '#' + gridInstance.element.id + '_searchbar'
          );
          if (searchEle) {
            searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
          }
        }}
      >
        <ColumnsDirective>
          <ColumnDirective
            field='PRODUCT_TRACKING_SITE'
            headerText='Site'
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_PLANTCLASS_ID'
            headerText='PlantClassID'
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_ASSET_NUMBER'
            headerText='Asset Number'
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_PRODDATE'
            headerText='ProdDate'
            editType='datepickeredit'
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_SHIFT'
            headerText='Shift'
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_PRESTARTNO'
            headerText='PreStartNo'
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_PRESTART_NO1'
            headerText='PreStartNo1'
            textAlign='Left'
            validationRules={orderidRules}
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_INDEXPRESTART'
            headerText='IndexPrestart'
            textAlign='Left'
            validationRules={orderidRules}
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_START_HOURS'
            headerText='Start Hours'
            textAlign='Left'
            validationRules={validationRule}
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_FINISH_HOURS'
            headerText='Finish Hours'
            validationRules={validationRule}
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_SMU_DELTA'
            headerText='SMU Delta'
            textAlign='Left'
            validationRules={orderidRules}
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_INDEXDELTA'
            headerText='IndexDelta'
            textAlign='Left'
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_COLUMN'
            headerText='.'
            textAlign='Left'
            validationRules={orderidRules}
          />
          <ColumnDirective
            field='PRODUCT_TRACKING_INDEXDATEDELTA'
            headerText='IndexDateDelta'
            textAlign='Left'
            editType='datepickeredit'
          />
          <ColumnDirective
            field='PRODUCT_INDEXDAYDELTA'
            headerText='IndexDayDelta'
            textAlign='Left'
            validationRules={orderidRules}
          />
        </ColumnsDirective>

        <AggregatesDirective>
          <AggregateDirective>
            <AggregateColumnsDirective>
              <AggregateColumnDirective
                field='PRODUCT_TRACKING_SITE'
                type='sum'
                footerTemplate={footerSum}
              />
              <AggregateColumnDirective
                field='PRODUCT_TRACKING_INDEXPRESTART'
                type='Sum'
                footerTemplate={footerSum}
              />
              <AggregateColumnDirective
                field='PRODUCT_TRACKING_PRESTART_NO1'
                type='Sum'
                footerTemplate={footerSum}
              />
              <AggregateColumnDirective
                field='PRODUCT_TRACKING_START_HOURS'
                type='Sum'
                footerTemplate={footerSum}
              />
              <AggregateColumnDirective
                field='PRODUCT_TRACKING_FINISH_HOURS'
                type='Sum'
                footerTemplate={footerSum}
              />
              <AggregateColumnDirective
                field='PRODUCT_TRACKING_SMU_DELTA'
                type='Sum'
                footerTemplate={footerSum}
              />
              <AggregateColumnDirective
                field='PRODUCT_TRACKING_COLUMN'
                type='Sum'
                footerTemplate={footerSum}
              />
              <AggregateColumnDirective
                field='PRODUCT_INDEXDAYDELTA'
                type='Sum'
                footerTemplate={footerSum}
              />
            </AggregateColumnsDirective>
          </AggregateDirective>
        </AggregatesDirective>

        <Inject
          services={[
            Edit,
            Toolbar,
            Filter,
            ColumnMenu,
            Resize,
            Aggregate,
            ExcelExport,
            Group,
          ]}
        />
      </GridComponent>
    </div>
  );
};
export default CPT;
